<template>
    <div>
        <template v-for="(item, index) in menuData">
        <!-- 因为有子集和无子集渲染html标签不一样，所以要分为两种情况
           情况一：有子集的情况：                         -->
            <el-submenu
                :key="index"
                :index="item.index"
                v-if="item.children.length > 0">
                <template slot="title">
                    <i :class="'iconfont ' + item.icon" style="font-size: 20px;margin-right:10px;"></i>
                    <span>{{ item.name }}</span>
                </template>
                <menu-tree :menuData="item.children"></menu-tree>
            </el-submenu>
            <!-- 情况二：没子集的情况： -->
            <el-menu-item :key="index" v-else :index="item.path">
                <i :class="'iconfont ' + item.icon" style="font-size: 20px;margin-right:10px;"></i>
                <span slot="title">{{ item.name }}</span>
            </el-menu-item>
        </template>
        <!-- <template v-for="(menu,index) in menuData">
            <el-submenu :key="index" :index="menu.index" v-if="menu.children.length > 0">
                <template slot="title">
                    <i :class="'iconfont' + menu.icon"></i>
                    <span slot="title">{{menu.name}}</span>
                </template>
                <menu-tree :menuData="menu.children"></menu-tree>
            </el-submenu>
            <el-menu-item :key="index" :index="menu.path" v-else>
                <i :class="'iconfont' + menu.icon"></i>
                <span slot="title">{{menu.name}}</span>
            </el-menu-item> 
        </template> -->
    </div>
</template>

<script>
export default {
    props: ['menuData'],
    name: 'MenuTree',
    methods: {
        getPath(item) {
            console.log(item)
        },
    }
}
</script>
<style lang="scss" >
.el-submenu__title i {
 color: #fff;
}
.el-menu--collapse {
 width: 54px;
}
</style>


// WEBPACK FOOTER //
// src/components/MenuTree.vue